import { DotLegalDialog, DotLegalTextField } from "@dotlegal/dotlegal-ui-components";
import { ChosenEntityToRelate } from "../../../../taskManagement/createTaskPane/CreateTaskPane.types";
import { useTranslation } from "../../../../localization/useTranslation";
import { useDotLegalNoteDialogHook } from "./DotLegalNoteDialog.hooks";
import { EntityType } from "../../../Common.types";
import { isNullOrWhitespace } from "../../../stringOperations";
import MentionInput from "../../mentionInput/MentionInput";

export interface INoteDialogProps {
    showDialog: boolean;
    noteText: string | undefined;
    onDialogClose: () => void;
    onNoteUpdated: () => void;
    isLoading?: boolean;
    disabled?: boolean;
    label?: string;
    header?: string;
    errorText?: string;
    postUrl?: string;
    entityId?: string;
    entityType?: EntityType;
    disableMentions?: boolean;
}

function DotLegalNoteDialog(props: INoteDialogProps) {
    const { translateString } = useTranslation();
    const { note, setNote, relations, setRelations, onSaveClick, isSaving } = useDotLegalNoteDialogHook(props);

    return (
        <DotLegalDialog
            isLoading={props.isLoading}
            size="md"
            header={props.header ?? translateString("note")}
            buttonOkText={translateString("save")}
            open={props.showDialog}
            onDialogClose={props.onDialogClose}
            onOkClick={() => onSaveClick()}
            inProgress={isSaving}
            hideOkButton={props.disabled}
            disableBackdropOnCloseIfValueChange={note}
        >
            <MentionInput
                disabled={props.disabled}
                label={props.label ?? translateString("notelabel")}
                value={note}
                debounce={false}
                multiline
                rows={12}
                onChange={(text, relations) => {
                    setNote(text);
                    setRelations(relations);
                }}
                manageRelationsExternal
                errorText={isNullOrWhitespace(note) && props.errorText ? props.errorText : ""}
                {...(props.disableMentions
                    ? { disableMentions: true as const }
                    : { mentionSource: { entityFromId: props.entityId ?? "", entityFromType: props.entityType ?? EntityType.LegalEntity } })}
            />
        </DotLegalDialog>
    );
}

export default DotLegalNoteDialog;
